import React, { Component, useMemo } from 'react'
import { Button, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import InfoWithTooltip from './InfoWithTooltip';
import { getLocale } from '../helpers/locale';
// import { hiddenReferralStatuses } from '../helpers/referral-statuses';
import { API_ENDPOINT } from '../constants';
import { Player } from '@lottiefiles/react-lottie-player';
import doubleArrowIcon from '../assets/svg/double-arrow-down-icon.svg';
import InlineSVG from 'react-inlinesvg';
import { getHumanReadableStatus } from '../views/payments/helper';

export class ReferralStatusHistoryModal extends Component { // referral.referralHistory ex referral.statusHistory

    constructor(props) {
        super(props)
        // props: isOpen, onClose, lang, history, country
        this.state = {
            isLoading: true,
            error: null,
            items: null,
        };
    }

    getReferralHistory() {
        if (!this.props.history) return this.setState({ isLoading: false, error: 'Cannot load referral history at this time! Please refresh your browser and try again.', items: null });

        this.setState({ isLoading: true, error: null, items: null }, async () => {
            const newState = {
                isLoading: false,
                error: null,
            }
            const url = `${API_ENDPOINT}/referrals/referral-history/${this.props.history}`;
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage?.getItem?.('authToken')}`
                }
            });
            const result = await response?.json?.();
            if (!result || result.error || !result.items || !Array.isArray(result.items) || !result.items.length) return this.setState({
                ...newState,
                error: result?.error || 'Cannot load referral history at this time! Please refresh your browser and try again.',
            });

            newState.items = result.items;
            this.setState(newState);
        });
    }

    componentDidMount() {
        this.getReferralHistory();
    }

    render() {

        const humanReadable = {
            'reserved': 'Time Slot Reserved'.translate(this.props.lang),
            'waiting-for-payment-before-submission': 'Waiting for payment'.translate(this.props.lang),
            'waiting-for-approval': 'Waiting for approval'.translate(this.props.lang),
            'waiting': 'Waiting'.translate(this.props.lang),
            'waiting-for-payment': 'Waiting for payment'.translate(this.props.lang),
            'disallowed': 'Disallowed'.translate(this.props.lang),
            'in-progress': 'In progress'.translate(this.props.lang),
            'allowed': 'Allowed'.translate(this.props.lang),
            'return-for-update': 'Return for update'.translate(this.props.lang),
            'patient-requested-another-time': 'Patient requested anoother time'.translate(this.props.lang),
            'patient-rejected': 'Cancelled by patient'.translate(this.props.lang), //  'Rejected by patient'.translate(this.props.lang),
            'patient-accepted': 'Patient accepted'.translate(this.props.lang),
            'clinic-accepted-requested-time': 'Clinic accepted requested time'.translate(this.props.lang),
            'clinic-rejected-requested-time': 'Clinic rejected requested time'.translate(this.props.lang),
            'approved-by-region-manager': 'Approved by region manager'.translate(this.props.lang),
            'rejected-by-region-manager': 'Rejected by region manager'.translate(this.props.lang),
            'scheduled': 'Scheduled'.translate(this.props.lang),
            'visit-rescheduled': 'Visit rescheduled'.translate(this.props.lang),
            'revisit-scheduled': 'Revisit scheduled'.translate(this.props.lang),
            'not-booked': 'Cancelled by clinician'.translate(this.props.lang), //'Not booked'.translate(this.props.lang),
            'closed': 'Closed'.translate(this.props.lang),
            'canceled-by-clinic': 'Cancelled by clinician'.translate(this.props.lang), // 'Canceled by clinic'.translate(this.props.lang),
            'requested-new-appointment': 'Requested new appointment'.translate(this.props.lang),
            'external': 'External transfer'.translate(this.props.lang),
            'not-scheduled': 'Not scheduled'.translate(this.props.lang),
        }

        const administrativeBooking = this.props.isOpen?.administrativeBooking;

        return (
            <Modal
                isOpen={this.props.isOpen}
                size='lg'
                centered
                key={this.props.history}
            >
                <ModalHeader
                    toggle={() => { this.props.onClose?.() }}
                    close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => {
                        this.props.onClose?.()
                    }}>&times;</button>}
                >
                    {'Referral History'.translate(this.props.lang)}
                    <InfoWithTooltip style={{ bottom: 4 }} lang={this.props.lang} text='Here you can see most important changes that have occured for this referral. Click on each item to expand and view the referral state snapshot at the time of the change in question. To compare state snapshots, expand multiple items.' />
                </ModalHeader>

                <ModalBody>
                    <Row>
                        <Col>
                            {this.state.isLoading ? <div key='loading'>
                                <Player
                                    autoplay={true}
                                    loop={true}
                                    src="/lf30_editor_l5cxzdyf.json"
                                    style={{ height: typeof window != 'undefined' && window.innerWidth < 768 ? "128px" : "256px", width: typeof window != 'undefined' && window.innerWidth < 768 ? "128px" : "256px" }}
                                />
                            </div> : this.state.error || !this.state.items?.length ? <div key='error'>
                                <p style={{
                                    textAlign: 'center',
                                    marginTop: 20,
                                    // fontWeight: '500',
                                }}>
                                    {(this.state.error || 'No referral history found!').translate(this.props.lang)}
                                </p>
                            </div> : <ul key='items' className='referral-history-list'>
                                {this.state.items?.map?.(item => {
                                    return <li key={item?.ts}>
                                        <ReferralStatusItem
                                            item={item}
                                            country={this.props.country}
                                            lang={this.props.lang}
                                            statusesHumanReadable={humanReadable}
                                            currency={this.props.currency}
                                            administrativeBooking={administrativeBooking}
                                            getStringDateTs={this.props.getStringDateTs}
                                        />
                                    </li>
                                })}
                            </ul>}
                        </Col>
                    </Row>
                </ModalBody>

                {/* <ModalBody>
                    <Row>
                        <Col>
                            <div className='e-connect-history-container'>
                                {this.props.history?.map?.(item => {
                                    if (!item || !item?.status || hiddenReferralStatuses.includes(item.status)) return null;
                                    const status = humanReadable[item.status] || item.status;

                                    const locale = getLocale(this.props.lang, this.props.country);
                                    const date = new Intl.DateTimeFormat(
                                        locale,
                                        {
                                            year: 'numeric',
                                            month: 'short',
                                            day: 'numeric',
                                            hour: 'numeric',
                                            minute: 'numeric',
                                        }
                                    ).format(item.ts * 1000);

                                    // const user = (['patient', 'system'].includes(item.user?.username) ? item.user.username.translate(this.props.lang) : item.user?.username) || 'N/A';
                                    const user = item.user?.username || 'N/A';

                                    return <div key={item.ts} className='e-connect-history-item e-connect-history-caseitem'>
                                        <div>{date}</div>
                                        <div>{status}</div>
                                        <div>{user}</div>
                                    </div>
                                })}
                            </div>
                        </Col>
                    </Row>
                </ModalBody> */}

                <ModalFooter
                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}
                >
                    <Button
                        color='primary'
                        onClick={() => { this.props.onClose?.() }}
                    >
                        {'Close'.translate(this.props.lang)}
                    </Button>
                </ModalFooter>
            </Modal>
        )
    }
}

const ignoredActionsInActionsArr = ['conversation-updated', 'case-updated'];

/**
 * 
 * @param {{
 *   item: {
 *     action: string;
 *     actions?: string[];
 *     ts: number;
 *     user: {type: 'user' | 'system'; id?: string | null; username: string;};
 *     state: {
 *       status: string;
 *       event?: {
 *         id: string;
 *         startTime: number;
 *         endTime: number;
 *       };
 *       form?: {
 *         name: string;
 *         price: number;
 *         isPaid: boolean;
 *       };
 *       payment: null;
 *       patient?: {
 *         id: string | null;
 *         ssn: string;
 *         name: string;
 *         dateOfBirth: string;
 *         role: 'patient';
 *         parents?: {
 *           id: string | null;
 *           ssn: string;
 *           name: string;
 *           dateOfBirth: string;
 *           role: 'parent';
 *         }[];
 *       };
 *       doctor?: {
 *         id: string | null;
 *         ssn: string;
 *         name: string;
 *         dateOfBirth: string;
 *         username: string;
 *         role: 'doctor';
 *       };
 *       clinic?: {
 *         id: string | null;
 *         name: string;
 *         subgroupName: string;
 *         groupId?: string;
 *         groupName?: string;
 *         groupAlias?: string;
 *       };
 *       conversation?: {
 *         id: string | null;
 *         status: 'open' | 'soft-closed' | 'closed';
 *         name: string;
 *         members: {
 *           id: string | null;
 *           ssn: string;
 *           name: string;
 *           dateOfBirth: string;
 *           username?: string;
 *           role: 'patient' | 'doctor' | 'additional-doctor' | 'parent';
 *         }[];
 *       };
 *       additionalDoctors?: {
 *         id: string | null;
 *         ssn: string;
 *         name: string;
 *         dateOfBirth: string;
 *         username: string;
 *         role: 'additional-doctor';
 *       }[];
 *     };
 *   };
 *   lang: string;
 *   country: string;
 *   statusesHumanReadable: {[key: string]: string};
 * }} param0 
 */

const getTimeFromTs = (ts, lang, country, getStringDateTs) => {
    if (!ts || typeof ts !== 'number') return 'N/A'.translate(lang);
    const format = 'DD MMM YYYY, HH:mm';
    if (getStringDateTs) {
        let formatted = getStringDateTs(ts, format, lang, country);
        const formattedMonth = getStringDateTs(ts, 'MMM', lang, country);
        formatted = formatted.replace(formattedMonth, formattedMonth.translate(lang));
        return formatted || 'N/A'.translate(lang);
    } else {
        const locale = getLocale(lang, country);

        return new Intl.DateTimeFormat(
            locale,
            {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
            }
        ).format(ts * 1000);
    }
}
const ReferralStatusItem = ({
    item,
    lang,
    statusesHumanReadable,
    currency,
    administrativeBooking,
    getStringDateTs
}) => {
    let ctr = typeof window !== 'undefined' && localStorage ? localStorage?.getItem?.('country') : 'sweden';
    let countryTwoLetter = typeof window !== 'undefined' && localStorage ? localStorage?.getItem?.('countryTwoLetter') : 'sweden';

    const country = React.useMemo(() => {
        if (['sweden', 'denmark'].includes(ctr)) return ctr;
        if (ctr === 'uk') {
            switch (countryTwoLetter) {
                case 'gb': return 'uk';
                case 'ch': return 'ch';
                case 'gr': return 'gr';
                case 'es': return 'es';
                case 'ae': return 'ae';
            }
        }

        return 'sweden';
    }, [ctr, countryTwoLetter]);

    const date = React.useMemo(() => {
        if (getStringDateTs) {
            return getTimeFromTs(item.ts, lang, country, getStringDateTs);
        }
        const locale = getLocale(lang, country);
        return new Intl.DateTimeFormat(
            locale,
            {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                // hour: 'numeric',
                // minute: 'numeric',
            }
        ).format(item.ts * 1000);
    }, [item, lang, country]);

    const fullDateTime = React.useMemo(() => {
        if (getStringDateTs) {
            return getTimeFromTs(item.ts, lang, country, getStringDateTs);
        }
        const locale = getLocale(lang, country);
        return new Intl.DateTimeFormat(
            locale,
            {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
            }
        ).format(item.ts * 1000);
    }, [item, lang, country]);

    const user = useMemo(() => {
        return (['patient', 'system'].includes(item.user?.username) ? item.user.username.translate(lang) : item.user?.username) || 'N/A';
    }, [item, lang]);

    const [isOpen, setIsOpen] = React.useState(false);

    const start = useMemo(() => {
        if (item.state?.event?.startTime) {
            const locale = getLocale(lang, country);
            if (getStringDateTs) {
                return getTimeFromTs(item.state.event.startTime, lang, country, getStringDateTs);
            }
            return new Intl.DateTimeFormat(
                locale,
                {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                }
            ).format(item.state.event.startTime * 1000);
        }

        return 'N/A'.translate(lang);
    }, [item, lang, country]);


    const end = useMemo(() => {
        if (item.state?.event?.endTime) {
            if (getStringDateTs) {
                return getTimeFromTs(item.state.event.endTime, lang, country, getStringDateTs);
            }
            const locale = getLocale(lang, country);
            return new Intl.DateTimeFormat(
                locale,
                {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                }
            ).format(item.state.event.endTime * 1000);
        }

        return 'N/A'.translate(lang);
    }, [item, lang, country]);

    const actions = useMemo(() => {
        let arr;
        if (item.action) {
            arr = !ignoredActionsInActionsArr.includes(item.action) ? [item.action] : [];
            if (item.actions && Array.isArray(item.actions) && item.actions.length > 0 && item.action !== 'additional-doctors-updated') {
                const acts = item.actions.filter(act => !ignoredActionsInActionsArr.includes(act));
                if (acts.length > 0) arr.push(...acts);
            }
        }

        if (!arr.length && item.action) arr.push(item.action);

        if (arr.includes('case-created')) arr = ['case-created'];

        return arr;
    }, [item]);

    if (item?.type === 'payment') {
        const doctorName = item?.state?.caseData?.doctorName || item?.state?.createdByUser?.name || 'N/A'.translate(lang);
        return <details onToggle={() => setIsOpen(prev => !prev)} open={isOpen}>
            <summary>
                <div>{date}</div>
                <div>{item.action.translate(lang)}</div>
                <div>{user}</div>
                <div className={isOpen ? 'rotate-svg-is-open' : undefined}><InlineSVG src={doubleArrowIcon} /></div>
            </summary>
            <div>
                {/* <p className='referral-history-title'>{'Referral state snapshot'}{': '}{fullDateTime}</p> */}
                <div>
                    <div className='referral-history-item'>
                        <p>{'Referral State'.translate(lang)}</p>
                        <div>
                            <div className='referral-history-item-data'>
                                <div>
                                    <div>{'Date and Time of Change'.translate(lang)}</div>
                                    <div>
                                        <p>{fullDateTime}</p>
                                    </div>
                                </div>
                            </div>
                            {actions && actions.length > 0 ? <div className='referral-history-item-data'>
                                <div>
                                    <div>{'Actions'.translate(lang)}</div>
                                    <div>
                                        {actions.map((act, i) => <p key={i}>{act.translate(lang)}</p>)}
                                    </div>
                                </div>
                            </div> : null}
                            {
                                item?.state?.caseData?.status ?
                                    <div className='referral-history-item-data'>
                                        <div>
                                            <div>{'Referral Status'.translate(lang)}</div>
                                            <div>
                                                <p>{statusesHumanReadable[item?.state?.caseData?.status] ?? 'N/A'.translate(lang)}</p>
                                            </div>
                                        </div>
                                    </div> : null
                            }


                        </div>
                    </div>

                    <div className='referral-history-item'>
                        <p>{'Clinic Data'.translate(lang)}</p>
                        <div>
                            {item.state.clinicInfo ? <div className='referral-history-item-data'>
                                {item.state.clinicInfo.groupName ? <div>
                                    <div>{'Clinic'.translate(lang)}</div>
                                    <div>
                                        <p>{item.state.clinicInfo.groupName}</p>
                                    </div>
                                </div> : null}
                                <div>
                                    <div>{'Department'.translate(lang)}</div>
                                    <div>
                                        <p>{item.state.clinicInfo.clinicName}{', '}{item.state.clinicInfo.clinicSubgroupName}</p>
                                    </div>
                                </div>
                            </div> : <p>{'N/A'.translate(lang)}</p>}
                        </div>
                    </div>
                    <div className='referral-history-item'>
                        <p>{'Patient Data'.translate(lang)}</p>
                        <div>
                            {item.state.patientData ? <div className='referral-history-item-data'>
                                <div>
                                    <div>{'Patient'.translate(lang)}</div>
                                    <div>
                                        <p>{item.state.patientData.name} {'('}{item.state.patientData.ssn}{')'}</p>
                                    </div>
                                </div>
                                {/* {item.state.patientData.parents ? item.state.patientData.parents.map(parent => <div key={parent.id || parent.ssn}>
                                    <div>{'Parent'.translate(lang)}</div>
                                    <div>
                                        <p>{parent.name} {'('}{parent.ssn}{')'}</p>
                                    </div>
                                </div>) : null} */}
                            </div> : <p>{'N/A'.translate(lang)}</p>}
                        </div>
                    </div>
                    <div className='referral-history-item'>
                        <p>{'Caregiver Data'.translate(lang)}</p>
                        <div>
                            {doctorName ? <div className='referral-history-item-data'>
                                <div>
                                    <div>{'Primary Caregiver'.translate(lang)}</div>
                                    <div>
                                        <p>{doctorName}</p>
                                    </div>
                                </div>
                                {/* {item.state.additionalDoctors ? item.state.additionalDoctors.map(doctor => <div>
                                    <div>{'Additional Caregiver'.translate(lang)}</div>
                                    <div>
                                        <p>{doctor.name} {doctor.username ? `(${doctor.username})` : null}</p>
                                    </div>
                                </div>) : null} */}
                            </div> : <p>{'N/A'.translate(lang)}</p>}
                        </div>
                    </div>
                    <div className='referral-history-item'>
                        <p>{'Form and Payment Data'.translate(lang)}</p>
                        <div>
                            <div className='referral-history-item-data'>
                                {
                                    item?.state?.caseData?.questionaryName ?
                                        <div>
                                            <div>{'Form/Visit Reason'.translate(lang)}</div>
                                            <div>
                                                <p>{item?.state?.caseData?.questionaryName || 'N/A'.translate(lang)}</p>
                                            </div>
                                        </div> : null
                                }

                                <div>
                                    <div>{'Price'.translate(lang)} {item.state?.amount?.currency ?? currency ?? ''}</div>
                                    <div>
                                        <p>{item.state?.amount?.value || 0}</p>
                                    </div>
                                </div>

                                {
                                    item?.state?.vat?.value ?
                                        <div>
                                            <div>{'VAT'.translate(lang)} {item.state?.amount?.currency ?? currency ?? ''}</div>
                                            <div>
                                                <p>{item.state?.vat?.value || 0}</p>
                                            </div>
                                        </div>
                                        : null
                                }
                                {
                                    item?.state?.amount?.refundAmount ?
                                        <div>
                                            <div>{'Refund amount'.translate(lang)} {item.state?.amount?.currency ?? currency ?? ''}</div>
                                            <div>
                                                <p>{item.state?.amount?.refundAmount || 0}</p>
                                            </div>
                                        </div>
                                        :
                                        null
                                }
                                <div>
                                    <div>{'Status'.translate(lang)}</div>
                                    <div>
                                        <p>{item.state?.status?.key ? getHumanReadableStatus(item.state?.status?.key, lang) : 'N/A'.translate(lang)}</p>
                                    </div>
                                </div>
                                {
                                    item?.state?.paymentMethod?.method?.[lang] ?
                                        <div>
                                            <div>{'Payment Method'.translate(lang)}</div>
                                            <div>
                                                <p>{item.state.paymentMethod.method[lang]}{item?.state?.paymentMethod?.status?.[lang] ? ` (${item.state.paymentMethod.status[lang]})` : ''}</p>
                                            </div>
                                        </div> : null
                                }
                                {
                                    item?.state?.paymentMethod?.method?.key === 'freeCard' && item?.state?.freeCardData ?
                                        <>
                                            <div>
                                                <div>{'Free kort number'.translate(lang)}</div>
                                                <div>
                                                    <p>{item?.state?.freeCardData?.number || 'N/A'.translate(lang)}</p>
                                                </div>
                                            </div>
                                            <div>
                                                <div>{'Valid from'.translate(lang)}</div>
                                                <div>
                                                    <p>{item?.state?.freeCardData?.valid?.from || 'N/A'.translate(lang)}</p>
                                                </div>
                                            </div>
                                            <div>
                                                <div>{'Valid to'.translate(lang)}</div>
                                                <div>
                                                    <p>{item?.state?.freeCardData?.valid?.to || 'N/A'.translate(lang)}</p>
                                                </div>
                                            </div>
                                            <div>
                                                <div>{'Issued at'.translate(lang)}</div>
                                                <div>
                                                    <p>{item?.state?.freeCardData?.regionData?.name || 'N/A'.translate(lang)}</p>
                                                </div>
                                            </div>
                                        </>
                                        :
                                        null
                                }
                                {
                                    item?.state?.reference ?
                                        <div>
                                            <div>{'Reference'.translate(lang)}</div>
                                            <div>
                                                <p>{item.state?.reference || 'N/A'.translate(lang)}</p>
                                            </div>
                                        </div> : null
                                }
                                {
                                    item?.state?.reason ?
                                        <div>
                                            <div>{'Reason'.translate(lang)}</div>
                                            <div>
                                                <p>{item.state?.reason || 'N/A'.translate(lang)}</p>
                                            </div>
                                        </div> : null
                                }

                            </div>
                        </div>
                    </div>
                    {
                        item?.state?.labels?.length ?
                            <div className='referral-history-item'>
                                <p>{'Labels'.translate(lang)}</p>
                                {
                                    item.state?.labels?.map((label, lIdx) => {
                                        let _label = label?.label?.[lang] ?? label?.label?.['se'] ?? label?.label?.['en'] ?? 'N/A'.translate(lang);
                                        return (
                                            <div>
                                                <div className='referral-history-item-data'>
                                                    <div>
                                                        <div>{'Label'.translate(lang)} </div>
                                                        <div>
                                                            <p>{_label}</p>
                                                        </div>
                                                    </div>

                                                    <div>
                                                        <div>{'Added by user'.translate(lang)} </div>
                                                        <div>
                                                            <p>{label?.user?.username || 'N/A'.translate(lang)}</p>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <div>{'Date and time'.translate(lang)} </div>
                                                        <div>
                                                            <p>{label?.time?.se || 'N/A'.translate(lang)}</p>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        )
                                    })
                                }

                            </div>
                            :
                            null
                    }
                    {
                        item?.state?.refunds?.length ?
                            <div className='referral-history-item'>
                                <p>{'Refunds'.translate(lang)}</p>
                                {
                                    item.state?.refunds?.map((refund, rIdx) => {
                                        return (
                                            <div>
                                                <div className='referral-history-item-data'>
                                                    <div>
                                                        <div>{'Refund amount'.translate(lang)} {item.state?.amount?.currency ?? currency ?? ''}</div>
                                                        <div>
                                                            <p>{refund?.amount}</p>
                                                        </div>
                                                    </div>

                                                    <div>
                                                        <div>{'Refunded by user'.translate(lang)} </div>
                                                        <div>
                                                            <p>{refund?.user?.username || 'N/A'.translate(lang)}</p>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <div>{'Date and time'.translate(lang)} </div>
                                                        <div>
                                                            <p>{refund?.time?.se || 'N/A'.translate(lang)}</p>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <div>{'Reason'.translate(lang)} </div>
                                                        <div>
                                                            <p>{refund?.reason?.[lang] || 'N/A'.translate(lang)}</p>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <div>{'Note'.translate(lang)} </div>
                                                        <div>
                                                            <p>{refund?.note || 'N/A'.translate(lang)}</p>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        )
                                    })
                                }

                            </div>
                            :
                            null
                    }
                    {
                        item?.state?.allReasons?.length ?
                            <div className='referral-history-item'>
                                <p>{'Reasons'.translate(lang)}</p>
                                {
                                    item.state?.allReasons?.map((reason, rIdx) => {
                                        return (
                                            <div>
                                                <div className='referral-history-item-data'>
                                                    <div>
                                                        <div>{'Type'.translate(lang)}</div>
                                                        <div>
                                                            <p>{reason?.type?.translate(lang) || 'N/A'.translate(lang)}</p>
                                                        </div>
                                                    </div>

                                                    <div>
                                                        <div>{'Added by user'.translate(lang)} </div>
                                                        <div>
                                                            <p>{reason?.user?.username || 'N/A'.translate(lang)}</p>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <div>{'Date and time'.translate(lang)} </div>
                                                        <div>
                                                            <p>{reason?.time?.se || 'N/A'.translate(lang)}</p>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <div>{'Reason'.translate(lang)} </div>
                                                        <div>
                                                            <p>{reason?.reason?.[lang] || 'N/A'.translate(lang)}</p>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <div>{'Note'.translate(lang)} </div>
                                                        <div>
                                                            <p>{reason?.note || 'N/A'.translate(lang)}</p>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        )
                                    })
                                }

                            </div>
                            :
                            null
                    }


                    {/* <div className='referral-history-item'>
                        <p>{'Appointment Data'.translate(lang)}</p>
                        <div>
                            {item.state.event ? <div className='referral-history-item-data'>
                                <div>
                                    <div>{'Start Time'.translate(lang)}</div>
                                    <div>
                                        <p>{start}</p>
                                    </div>
                                </div>
                                <div>
                                    <div>{'End Time'.translate(lang)}</div>
                                    <div>
                                        <p>{end}</p>
                                    </div>
                                </div>
                            </div> : <p>{'N/A'.translate(lang)}</p>}
                        </div>
                    </div>
                    <div className='referral-history-item'>
                        <p>{'Conversation Data'.translate(lang)}</p>
                        <div>
                            {item.state.conversation ? <div className='referral-history-item-data'>
                                <div>
                                    <div>{'Title'.translate(lang)}</div>
                                    <div>
                                        <p>{item.state.conversation.name || 'N/A'.translate(lang)}</p>
                                    </div>
                                </div>
                                <div>
                                    <div>{'Status'.translate(lang)}</div>
                                    <div>
                                        <p>{item.state.conversation.status ? item.state.conversation.status.translate(lang) : 'N/A'.translate(lang)}</p>
                                    </div>
                                </div>
                                <div>
                                    <div>{'Members'.translate(lang)}</div>
                                    <div>
                                        {item.state.conversation.members ? item.state.conversation.members.map(member => <p key={member.id || member.ssn}>{member.name} {member.role === 'patient' || member.role === 'parent' ? member.ssn ? `(${member.ssn})` : null : member.username ? `(${member.username})` : null}</p>) : 'N/A'.translate(lang)}
                                    </div>
                                </div>

                            </div> : <p>{'N/A'.translate(lang)}</p>}
                        </div>
                    </div> */}
                </div>
            </div>
        </details>;
    }

    return <details onToggle={() => setIsOpen(prev => !prev)} open={isOpen}>
        <summary>
            <div>{date}</div>
            <div>{item.action.translate(lang)}</div>
            <div>{user}</div>
            <div className={isOpen ? 'rotate-svg-is-open' : undefined}><InlineSVG src={doubleArrowIcon} /></div>
        </summary>
        <div>
            {/* <p className='referral-history-title'>{'Referral state snapshot'}{': '}{fullDateTime}</p> */}
            <div>
                <div className='referral-history-item'>
                    <p>{'Referral State'.translate(lang)}</p>
                    <div>
                        <div className='referral-history-item-data'>
                            <div>
                                <div>{'Date and Time of Change'.translate(lang)}</div>
                                <div>
                                    <p>{fullDateTime}</p>
                                </div>
                            </div>
                        </div>
                        {actions && actions.length > 0 ? <div className='referral-history-item-data'>
                            <div>
                                <div>{'Actions'.translate(lang)}</div>
                                <div>
                                    {actions.map((act, i) => <p key={i}>{act.translate(lang)}</p>)}
                                </div>
                            </div>
                        </div> : null}
                        <div className='referral-history-item-data'>
                            <div>
                                <div>{'Referral Status'.translate(lang)}</div>
                                <div>
                                    <p>{statusesHumanReadable[item.state.status] ?? 'N/A'.translate(lang)}</p>
                                </div>
                            </div>
                        </div>
                        {
                            item.state.reason !== '' ?
                                <div className='referral-history-item-data'>
                                    <div>
                                        <div>{'Rescheduling/Cancellation reason'.translate(lang)}</div>
                                        <div>
                                            <p>{item.state.reason ?? 'N/A'.translate(lang)}</p>
                                        </div>
                                    </div>
                                </div>
                                :
                                null
                        }
                    </div>
                </div>
                <div className='referral-history-item'>
                    <p>{'Check in data'.translate(lang)}</p>
                    <div>
                        {item.state?.checkIn ? (
                            <div className='referral-history-item-data'>
                                <div>
                                    <div>{'Marked for check in'.translate(lang)}</div>
                                    <div>
                                        <p>{item.state.checkIn.isMarkedForCheckIn ? 'Yes'.translate(lang) : 'No'.translate(lang)}</p>
                                    </div>
                                </div>

                                {item.state.checkIn.ts ? (
                                    <div>
                                        <div>{'Marked at'.translate(lang)}</div>
                                        <div>
                                            <p>
                                                {new Intl.DateTimeFormat(getLocale(lang, country), {
                                                    year: 'numeric',
                                                    month: 'short',
                                                    day: 'numeric',
                                                    hour: 'numeric',
                                                    minute: 'numeric',
                                                    second: 'numeric',
                                                }).format(item.state.checkIn.ts * 1000)}
                                            </p>
                                        </div>
                                    </div>
                                ) : null}

                                {item.state.checkIn.by ? (
                                    <div>
                                        <div>{'Marked by'.translate(lang)}</div>
                                        <div>
                                            <p>{item.state.checkIn.by}</p>
                                        </div>
                                    </div>
                                ) : null}
                            </div>
                        ) : (
                            <p>{'N/A'.translate(lang)}</p>
                        )}
                    </div>
                </div>
                <div className='referral-history-item'>
                    <p>{'Clinic Data'.translate(lang)}</p>
                    <div>
                        {item.state.clinic ? <div className='referral-history-item-data'>
                            {item.state.clinic.groupName ? <div>
                                <div>{'Clinic'.translate(lang)}</div>
                                <div>
                                    <p>{item.state.clinic.groupName}</p>
                                </div>
                            </div> : null}
                            <div>
                                <div>{'Department'.translate(lang)}</div>
                                <div>
                                    <p>{item.state.clinic.name}{', '}{item.state.clinic.subgroupName}</p>
                                </div>
                            </div>
                        </div> : <p>{'N/A'.translate(lang)}</p>}
                    </div>
                </div>
                <div className='referral-history-item'>
                    <p>{'Patient Data'.translate(lang)}</p>
                    <div>
                        {item.state.patient ? <div className='referral-history-item-data'>
                            <div>
                                <div>{'Patient'.translate(lang)}</div>
                                <div>
                                    <p>{item.state.patient.name} {'('}{item.state.patient.ssn}{')'}</p>
                                </div>
                            </div>
                            {item.state.patient.parents ? item.state.patient.parents.map(parent => <div key={parent.id || parent.ssn}>
                                <div>{'Parent'.translate(lang)}</div>
                                <div>
                                    <p>{parent.name} {'('}{parent.ssn}{')'}</p>
                                </div>
                            </div>) : null}
                        </div> : <p>{'N/A'.translate(lang)}</p>}
                    </div>
                </div>
                <div className='referral-history-item'>
                    <p>{'Caregiver Data'.translate(lang)}</p>
                    <div>
                        {item.state.doctor ? <div className='referral-history-item-data'>
                            <div>
                                <div>{'Primary Caregiver'.translate(lang)}</div>
                                <div>
                                    <p>{item.state.doctor.name} {item.state.doctor.username ? `(${item.state.doctor.username})` : null}</p>
                                </div>
                            </div>
                            {item.state.additionalDoctors ? item.state.additionalDoctors.map(doctor => <div>
                                <div>{'Additional Caregiver'.translate(lang)}</div>
                                <div>
                                    <p>{doctor.name} {doctor.username ? `(${doctor.username})` : null}</p>
                                </div>
                            </div>) : null}
                        </div> : <p>{'N/A'.translate(lang)}</p>}
                    </div>
                </div>
                {
                    !administrativeBooking ?
                        <div className='referral-history-item'>
                            <p>{'Form and Payment Data'.translate(lang)}</p>
                            <div>
                                {item.state.form ? <div className='referral-history-item-data'>
                                    <div>
                                        <div>{'Form/Visit Reason'.translate(lang)}</div>
                                        <div>
                                            <p>{item.state.form.name || 'N/A'.translate(lang)}</p>
                                        </div>
                                    </div>
                                    <div>
                                        <div>{'Price'.translate(lang)} {currency ?? ''}</div>
                                        <div>
                                            <p>{item.state.form.price || 0}</p>
                                        </div>
                                    </div>
                                    <div>
                                        <div>{'Status'.translate(lang)}</div>
                                        <div>
                                            <p>{item.state.form.price === 0 ? 'Paid'.translate(lang) : item.state.form.isPaid ? 'Paid'.translate(lang) : 'Unpaid'.translate(lang)}</p>
                                        </div>
                                    </div>
                                </div> : <p>{'N/A'.translate(lang)}</p>}
                            </div>
                        </div>
                        :
                        null
                }

                <div className='referral-history-item'>
                    <p>{'Appointment Data'.translate(lang)}</p>
                    <div>
                        {item.state.event ? <div className='referral-history-item-data'>
                            <div>
                                <div>{'Start Time'.translate(lang)}</div>
                                <div>
                                    <p>{start}</p>
                                </div>
                            </div>
                            <div>
                                <div>{'End Time'.translate(lang)}</div>
                                <div>
                                    <p>{end}</p>
                                </div>
                            </div>
                        </div> : <p>{'N/A'.translate(lang)}</p>}
                    </div>
                </div>
                {
                    !administrativeBooking ?
                        <div className='referral-history-item'>
                            <p>{'Conversation Data'.translate(lang)}</p>
                            <div>
                                {item.state.conversation ? <div className='referral-history-item-data'>
                                    <div>
                                        <div>{'Title'.translate(lang)}</div>
                                        <div>
                                            <p>{item.state.conversation.name || 'N/A'.translate(lang)}</p>
                                        </div>
                                    </div>
                                    <div>
                                        <div>{'Status'.translate(lang)}</div>
                                        <div>
                                            <p>{item.state.conversation.status ? item.state.conversation.status.translate(lang) : 'N/A'.translate(lang)}</p>
                                        </div>
                                    </div>
                                    <div>
                                        <div>{'Members'.translate(lang)}</div>
                                        <div>
                                            {item.state.conversation.members ? item.state.conversation.members.map(member => <p key={member.id || member.ssn}>{member.name} {member.role === 'patient' || member.role === 'parent' ? member.ssn ? `(${member.ssn})` : null : member.username ? `(${member.username})` : null}</p>) : 'N/A'.translate(lang)}
                                        </div>
                                    </div>

                                </div> : <p>{'N/A'.translate(lang)}</p>}
                            </div>
                        </div>
                        :
                        null
                }

            </div>
        </div>
    </details>;
}

export default ReferralStatusHistoryModal